/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

const { email, socialMedia } = require('./src/config');

// A little hello for anyone who opens DevTools
exports.onClientEntry = () => {
  const github = socialMedia.find(({ name }) => name === 'GitHub');

  // prettier-ignore
  const logo = [
    '   _____',
    '  /     \\',
    ' /   A   \\',
    ' \\       /',
    '  \\_____/',
  ].join('\n');

  const mono = 'font-family: "SF Mono", Menlo, Consolas, monospace;';

  /* eslint-disable no-console */
  console.log(`%c${logo}`, `${mono} color: #da4167; font-size: 14px; line-height: 1.2;`);
  console.log(
    '%cAnish Kapse.',
    'background: #18191b; color: #ccd6f6; font-size: 18px; font-weight: 600; padding: 6px 12px; border-radius: 4px;',
  );
  console.log(
    '%cOh hey, you opened the console. Curious — I like that.',
    'font-size: 13px; padding-top: 8px;',
  );
  console.log(
    `%cSay hi%c ${email}\n%cMore of my work%c ${github ? github.url : ''}`,
    `${mono} color: #da4167;`,
    'color: inherit;',
    `${mono} color: #da4167;`,
    'color: inherit;',
  );
  /* eslint-enable no-console */
};
